export interface OfficeLocation {
    id: string;
    name: string;
    address: string;
    mapsLink: string;
    phone: string;
}

export const OFFICE_LOCATIONS: OfficeLocation[] = [
    {
        id: 'merkez',
        name: 'Merkez Ofis',
        address: 'Huzur, Azerbaycan Cd. No:4 B Blok Kat: 8 Ofis No: 125-126-127 Skyland, 34415 Sarıyer/İstanbul',
        mapsLink: 'https://maps.app.goo.gl/mavjG1GuQiSCBtqh8',
        phone: '0212 544 24 15'
    },
    {
        id: 'kadikoy',
        name: 'Kadıköy Ofis',
        address: 'Osmanağa Mah. General Asım Gündüz Cad, Bahariye, Nevzemin Sk. No:2/20 Kat:5, 34714 Kadıköy/İstanbul',
        mapsLink: 'https://maps.app.goo.gl/NH8ZDeJZtQRbYquW7',
        phone: '0216 414 24 15'
    },
    {
        id: 'izmir',
        name: 'İzmir Ofis',
        address: 'Soğukkuyu, 1595. Sk. Karşıyaka Plaza No: 1 Kat: 6 Ofis No: 35, 35100 Bayraklı/İzmir',
        mapsLink: 'https://maps.app.goo.gl/7V5GhKpHoMURJK7ZA',
        phone: '0232 202 82 15'
    },
    {
        id: 'bursa',
        name: 'Bursa Ofis',
        address: 'İhsaniye Mh. FSM Bulvarı Aydemir - Rızvanoğlu İş Merkezi No.12/C A Blok Kat: 10 D:63, 16130 Ni̇lüfer/Bursa',
        mapsLink: 'https://maps.app.goo.gl/9s6RP2PJefr9RYqA6',
        phone: '0224 504 24 15'
    },
    {
        id: 'fethiye',
        name: 'Fethiye Ofis',
        address: 'Akarca, Mustafa Kemal Blv. No:173 B (Hipokampüs, 48300 Fethiye/Muğla',
        mapsLink: 'https://maps.app.goo.gl/NXh3EJVeddRZsvW1A',
        phone: '0252 320 00 15'
    },
    {
        id: 'ankara',
        name: 'Ankara Ofis',
        address: 'Kızılırmak Mh.1443 Cd No:9 YDA Center A/3 Blok Kat:6 Ofis Numarası:177, 06510 Çankaya/Ankara',
        mapsLink: 'https://maps.app.goo.gl/2qmm7WXgudGN8NDY6',
        phone: '0312 543 54 53'
    }
];
